import React, { useEffect, useState } from 'react';
import HTTP from '../../../config/axios';
import DataTable from 'react-data-table-component';
import { Button, Row, Col, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { dateIsToday, dateTimeDistance, getLongFormatOfDateAndTime, getParsedDate } from '../../../config/utils/dateFunctions';
import SimpleToast from '../../common/Toast';
import SimpleSpinner from "../../common/Spinner";
import MultiRadio from '../../form/MultiRadio';
import InputGroupField from '../../form/InputGroupField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faSearch } from '@fortawesome/free-solid-svg-icons';
import ImageCellForDataTable from '../../common/ImageCellForDataTable';
import { downloadFileFromApi, priceFormat } from '../../../config/utils/helper';
import { encryptLocalStorage } from '../../../config/utils/storage';
import DropDownField from '../../form/DropDownField';


const TestDriveDataTable: React.FC<any> = () => {

    const [sortDetails, setSortDetails] = useState({ sortColumn: '', sortDirection: '' })
    const { control, watch, getValues, reset } = useForm<Record<string, any>>({ defaultValues: { search: "", contactStatus: "All", dealership: "" } });
    const [perPage, setPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [isLoading, setIsLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [testDrive, setTestDrive] = useState([]);
    const [updatedRow, setUpdatedRow] = useState(false);
    const searchText = watch('search');
    const [toast, setToast] = useState({ open: false, header: '', message: '', variant: '' })
    const testDriveStatus = watch("driveStatus")
    const [checkedStatus, setCheckedStatus] = useState<{ [key: number]: boolean }>({});
    const [userRoleWeight, setUserRoleWeight] = useState(0);
    const [defaultDealership, setDefaultDealership] = useState('');
    const selectedDealership = watch('dealership');
    const [dealershipData, setDealershipData] = useState([])


    const customStyles = {
        headCells: {
            style: {
                fontSize: "15px",
                fontWeight: "700"
            },
        },
    };

    const testDriveStatuses = [
        // { label: 'All', value: 'All' },
        { label: 'Not Completed', value: '1' },
        { label: 'Completed', value: '2' },
    ]


    const column: any = [
        {
            name: 'Name',
            selector: (row: { firstName: string; lastName: string }) => `${row.firstName} ${row.lastName || ''}`,
            sortable: true,
            keyName: 'authUser.userProfile.first_name',
        },
        {
            name: 'Contact no',
            selector: (row: { phone: string; }) => row.phone,
            keyName: 'mobileNo',
        }, {
            name: 'Vehicle',
            selector: (row: { makeName: string, modelName: string, variantName: string }) => { return (`${row.makeName} ${row.modelName} ${row.variantName}`) },
            keyName: 'makeName',
            wrap: true,
        }, {
            name: 'Registration',
            selector: (row: { registration: string }) => row.registration
        },
        {
            name: 'Outlet',
            selector: (row: { outletName: string }) => row.outletName
        },
        {
            name: 'Dealership',
            selector: (row: { dealershipName: string }) => row.dealershipName
        },

        {
            name: <div>Scheduled At</div>,
            selector: (row: { dateTime: string }) => getLongFormatOfDateAndTime(row.dateTime),
            sortable: true,
            wrap: true,
            keyName: 'dateTime'
        }
        , {
            name: 'Updated At',
            sortable: true,
            wrap: true,
            keyName: 'updatedAt',
            selector: (row: { updatedAt: string; }) => dateIsToday(row.updatedAt) ? dateTimeDistance(row.updatedAt)
                : getLongFormatOfDateAndTime(row.updatedAt),
        },
        {
            name: 'Complete Status',
            selector: (row: { id: number, status: number }) => <>
                <Form.Check className='ms-5' checked={checkedStatus[row.id]} type='checkbox' id={row.id + 'completeStatus'}
                    onChange={(e) => {
                        statusChange(row.id, e.target.checked)
                    }}
                /> </>,
        },

    ]
    useEffect(() => {
        try {
            const getAllDealerships = async () => {
                try {
                    setIsLoading(true)
                    const dealershipStatus = 1
                    const params = { status: dealershipStatus };
                    const response = await HTTP.get(`/api/admin/dealership/fetch-all`, { params });
                    const { data: { status, data, msg, error, totalRecords } } = response;
                    const dealershipOptions = data.map((dealership: any) => ({
                        keyName: dealership.id,
                        name: dealership.name
                    }));
                    setDealershipData(dealershipOptions);
                } catch (error: any) {
                    if (error.response?.status === 401) {
                        setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to access this resource', variant: 'danger' })
                    } else {
                        setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
                    }
                }
            }
            getAllDealerships()
        }
        catch (error) {
            console.log("Error in dealership fetch api")
        }
        finally {
            setIsLoading(false)
        }
    }, []);

    useEffect(() => {
        const user = encryptLocalStorage.getItem('userInfo');
        const accessibleDealership = encryptLocalStorage.getItem('accessibleDealership');
        const dealershipValues = [...new Set(accessibleDealership)];
        
        setUserRoleWeight(user?.roleWeight || 0);
        
        // For users below roleWeight 90, set default dealership
        if (user?.roleWeight < 90 && dealershipValues.length > 0) {
            const defaultValue = String(dealershipValues[0]);
            setDefaultDealership(defaultValue);
            reset({ dealership: defaultValue });
        }
    }, []);

    useEffect(() => {
        try {
            const getAllTestDrive = async () => {
                try {
                    setIsLoading(true);
                    const accessibleOutlets = encryptLocalStorage.getItem('accessibleOutlets');
                    const dealershipId = selectedDealership || defaultDealership;
                    const params = {
                        searchText: searchText, sortDetails: JSON.stringify(sortDetails),
                        completeStatus: testDriveStatus,
                        ...(dealershipId ?
                            { dealershipId: dealershipId } :
                            { accessibleOutlets: accessibleOutlets })
                    };
                    const response = await HTTP.get(`/api/admin/test-drive/fetch-all/${currentPage}/${perPage}`, { params });
                    const { data: { status, data, msg, error, totalRecords } } = response;
                    const updatedRowCheckedStatus: { [key: number]: boolean } = {};
                    data.rows.forEach((row: any) => {
                        updatedRowCheckedStatus[row.id] = row.status === 2; // Assuming 2 means checked(test Drive Completed)
                        setCheckedStatus(updatedRowCheckedStatus)
                    });
                    setTestDrive(data.rows)
                    setTotalRows(data.count)
                } catch (error: any) {
                    if (error.response?.status === 401) {
                        setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to access this resource', variant: 'danger' })
                    } else {
                        setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
                    }
                }
            }
            getAllTestDrive()
        }
        catch (e) {
            setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
        }
        finally {
            setIsLoading(false)
        }

    }, [currentPage, perPage, searchText, sortDetails, testDriveStatus, updatedRow, selectedDealership, defaultDealership, userRoleWeight]);


    //Handle the test drive status change
    const statusChange = async (id: number, checked: boolean) => {
        try {

            setCheckedStatus((prevStatus) => ({
                ...prevStatus,
                [id]: checked,
            }));
            const params = { id: id, status: checked ? 2 : 1 };
            const response = await HTTP.post(`/api/admin/test-drive/updateStatus`, params);
            const { data: { status, message, error } } = response;
            if (status) {
                setUpdatedRow(!updatedRow)
            }
            setToast({ open: true, header: status ? 'Success' : "Failed", message: status ? "Updated Successfully" : 'Something went wrong', variant: status ? 'success' : 'danger' })
        } catch (error: any) {
            if (error.response?.status === 401) {
                setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to perform this action', variant: 'danger' })
            } else {
                setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
            }
        }
    }


    //Handling the page changes
    const handlePageChange = (page: any) => {
        setCurrentPage(page)
    }

    //handling the no.of rows changing
    const handlePerRowsChange = async (newPerPage: number, page: number) => {
        setPerPage(newPerPage)
    };


    //Handling the sort
    const handleSort = (column: any, sortDirection: any) => {
        const columnDetails = { sortColumn: column.keyName, sortDirection: sortDirection }
        setSortDetails(columnDetails)
    }

    //Function to download CSV
    const getAllTestDriveExcel = async () => {
        try {
            const accessibleOutlets = encryptLocalStorage.getItem('accessibleOutlets');

            setIsLoading(true);
            const dealershipId = selectedDealership || defaultDealership;
            const params = {
                searchText: searchText, sortDetails: JSON.stringify(sortDetails),
                completeStatus: testDriveStatus,
                ...(dealershipId ?
                    { dealershipId: dealershipId } :
                    { accessibleOutlets: accessibleOutlets })
            };
            const response = await HTTP.get(`/api/admin/test-drive/fetch-all/excel`, { params, responseType: 'blob', });
            const filename = response.headers['content-disposition'].split('filename="')[1].split('"')[0];
            downloadFileFromApi(response.data, filename)
        } catch (error: any) {
            if (error.response?.status === 401) {
                setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to access this resource', variant: 'danger' })
            } else {
                console.log("Error in enquery download api", error);
            }
        } finally {
            setIsLoading(false);
        }
    }

    return (<>
        <Row className='mb-1'>
            <div className="d-flex">
                <div className="p-2 flex-grow-1"><h2 className="mb-0 text-gray">Test&nbsp;Drives</h2></div>
                <div className='p-2 mt-2'>
                    <label className="form-label mb-0 me-0 fw-semibold text-nowrap">Dealership:</label>
                </div>
                <div className='p-2'>
                 
                    <div className="ms-auto" style={{ width: '100%' }}>
                        <DropDownField
                            name="dealership"
                            options={dealershipData}
                            control={control}
                            placeholder="Choose Dealership"
                            isValueKeyname={true}
                            isDisabled={userRoleWeight < 90}
                        />
                    </div>
                </div>
                <div className="p-2 mt-2 text-success" title="Download Excel Report">
                    <FontAwesomeIcon icon={faFileExcel} size='lg' onClick={getAllTestDriveExcel} style={{ cursor: 'pointer' }} />
                </div>
                <div className="p-2 mt-2 d-flex " style={{ cursor: "pointer" }}>
                    <MultiRadio name="driveStatus" control={control}
                        options={testDriveStatuses} classList="mb-3 pt-0 px-2" selectedValue={watch("driveStatus")} />
                </div>
                <div className="p-2"><InputGroupField name="search" placeholder="Search" label="" control={control} addOn={faSearch} /></div>
            </div>
        </Row>

        <DataTable
            columns={column}
            data={testDrive}
            striped={true}
            //progressPending={isLoading}
            onSort={handleSort}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            highlightOnHover={true}
            customStyles={customStyles}
        />
        <SimpleToast show={toast.open} header={toast.header}
            message={toast.message} variant={toast.variant}
            onClose={() => setToast({ ...toast, open: false })} />
        <SimpleSpinner show={isLoading} />

    </>)
}

export default TestDriveDataTable